// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import { css } from "glamor";
import SkewedContainer from "sc-react";
import React, { Component } from "react";
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
import { Page } from "@bodhi-project/semantic-webflow";
import {
  // --------------- Basic
  UpdateTitle,
  GeneralMeta,
  // --------------- Twitter
  TwitterSummaryCard,
  // --------------- Open Graph
  OpenGraphSummary,
  // --------------- Schema.org JSON-LD
  WebpageSchema,
  BreadcrumbSchema
} from "@bodhi-project/seo";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Images
import LandingBanner from "../blocks/LandingBanner";
import LandingFeatures from "../blocks/LandingFeatures";
// import Twitter from "../blocks/Twitter";
import InfoTabs from "../blocks/InfoTabs";
import seoHelper from "../helpers/seoHelper";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstract stuff
const { Fragment } = React;

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------------ SEO
// ----------------------------------------------------------------------------
const pageData = {
  pageTitle: "Secured Adobe DRM Integration Web Services",
  nakedPageSlug: "",
  pageAbstract:
    "Digital Media Reserve offers Web Services which includes a centralized repository of ebook files and the sales fulfillment of DRM protected ebooks (EPUB and PDF/A Formats). A Web Service is a method of communications between two electronic devices over the World Wide Web. Publishers upload their ebook (EPUB and PDF/A) files to Digital Media Reserve's digital warehouse. Publisher and Retailers can integrate with Digital Media Reserve in order to sell ebooks from their own Websites."
};

const seoData = seoHelper(pageData);

const {
  pageTitle,
  generalMetaData,
  twitterSummaryCardData,
  openGraphSummaryData,
  webpageSchemaData,
  breadcrumbSchemaData
} = seoData;

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Styles
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Page style
const pageStyle = css({});
const pageStyleClass = pageStyle.toString();

// ----------------------------------------------------------------------- Component
/** IndexPage */
class IndexPage extends React.Component {
  /** standard renderer */
  render() {
    return (
      <Fragment>
        {/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ SEO */}
        <UpdateTitle title={pageTitle} />
        <GeneralMeta data={generalMetaData} />
        <TwitterSummaryCard data={twitterSummaryCardData} />
        <OpenGraphSummary data={openGraphSummaryData} />
        <WebpageSchema data={webpageSchemaData} />
        <BreadcrumbSchema data={breadcrumbSchemaData} />
        {/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Page */}
        <Page className={pageStyleClass}>
          <LandingBanner />
          <SkewedContainer top="right" bottom="left" bgColor="#c32148" noMargin>
          <LandingFeatures />
          
          </SkewedContainer>
          <SkewedContainer top="right" bgColor="#4682B4" noMargin>
              <InfoTabs />
          </SkewedContainer>
        </Page>
      </Fragment>
    );
  }
}

IndexPage.propTypes = {};

// ----------------------------------------------------------------------- Export

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.jsx